// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hmAE","input":"styles_input__3UZYa"};